module.exports = __webpack_public_path__ + "static/media/icon-supplies-tweezers.386338ba.svg";